
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypePilotOutlined as ObiVesselTypePilotOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-pilot-outlined.js';
 
 
 

 
 export const ObiVesselTypePilotOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-pilot-outlined',
   elementClass: ObiVesselTypePilotOutlinedElement,
   events: {
     
   }
  });
 
 